<template>
  <div v-if="website" class="ba-grid ba-gp-08">
    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe ba-gp-06">
      <button
        type="button"
        class="ba-btn ba-blue ba-md"
        @click.prevent="$refs.actionEmail.open()"
      >
        <builderall-icon code="2780" />
        {{ $t("ct-email-new-theme") }}
      </button>
      <button
        type="button"
        class="ba-btn ba-green ba-md"
        @click.prevent="save()"
      >
        {{ $t("ct-save") }}
      </button>
    </div>
    <div class="ba-w-100">
      <form @submit.prevent="">
        <div
          id="accordion-emails"
          class="container-accordion-form ba-grid ba-gp-08"
        >
          <alert-box-component type="warning">
            <p slot="content">
              {{ $t("ct-restrict-email-config-warning") }}
              <router-link
                :to="{
                  name: 'GeneralSettings',
                  params: { id: website.encrypted_id }
                }"
                class="ba-text-underline"
              >
                {{ $t("ct-website-settings") }}
              </router-link>
            </p>
          </alert-box-component>

          <div
            v-for="(theme, indx) in emails.themes"
            v-if="emails.themes.length > 0"
            :key="indx"
            class="container-accordion-form "
          >
            <div class="card ba-w-100">
              <div
                :class="{ collapsed: !theme.expanded }"
                :data-target="`#collapseEmailTheme${indx}`"
                :aria-expanded="theme.expanded"
                :aria-controls="`collapseEmailTheme${indx}`"
                class="card-header ba-flex ba-jc-sb ba-ai-center"
                data-toggle="collapse"
              >
                <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                  {{ $t(theme.name) }}
                </span>
                <div class="ba-flex ba-gp-06">
                  <button
                    type="button"
                    class="ba-btn ba-btn-normal ba-sm ba-rounded"
                    @click.stop.prevent="editEmailTheme(theme)"
                  >
                    <builderall-icon code="edit" />
                  </button>
                  <button
                    type="button"
                    class="ba-btn ba-btn-trash ba-sm ba-rounded"
                    @click.stop.prevent="deleteEmailTheme(indx)"
                  >
                    <builderall-icon code="trash" />
                  </button>
                  <span class="d-inline-block float-right">
                    <font-awesome-icon
                      :icon="['fas', 'chevron-down']"
                      class="font-awesome-icon danger"
                    />
                  </span>
                </div>
              </div>
              <div
                :id="`collapseEmailTheme${indx}`"
                :aria-labelledby="`headingEmailTheme${indx}`"
                class="collapse"
                data-parent="#accordion-emails"
              >
                <div class="card-body">
                  <nav>
                    <div id="nav-tab" class="nav nav-tabs" role="tablist">
                      <a
                        v-for="(config, index) in theme.configs"
                        :id="`nav-${index}-${config.type}-tab`"
                        :href="`#nav-${index}-${config.type}`"
                        :aria-controls="`nav-${index}-${config.type}`"
                        class="nav-item nav-link active"
                        data-toggle="tab"
                        role="tab"
                        aria-selected="true"
                        ><span class="ba-montserrat-700 ba-text-14">{{
                          $t(`ct-email-theme-${config.type}`)
                        }}</span>
                      </a>
                      <hr class="ba-hr-row" />
                    </div>
                  </nav>
                  <div id="nav-tabContent" class="tab-content">
                    <div
                      v-for="(config, index) in theme.configs"
                      :id="`nav-${index}-${config.type}`"
                      :aria-labelledby="`nav-${index}-${config.type}-tab`"
                      class="tab-pane fade show active p-2"
                      role="tabpanel"
                    >
                      <div class="ba-grid ba-w-100">
                        <label for="subject" class="ba-custom-label">{{
                          $t("ct-subject")
                        }}</label>
                        <input
                          id="subject"
                          v-model="config.subject"
                          type="text"
                          class="ba-input ba-md"
                        />
                      </div>
                      <div class="ba-w-100 ba-pd-t-1">
                        <!-- <textarea v-model="config.content" class="form-control"></textarea> -->
                        <CKEditor
                          v-model="config.content"
                          :id="
                            `CKEditor-${indx}-${theme.name
                              .replace(' ', '-')
                              .replace(/[^\w\s]/gi, '')}`
                          "
                          :toolbar="CKEditor_config.toolbar"
                          :full-page="false"
                          :height="CKEditor_config.height"
                          :tags="tags"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <builderall-empty-image v-else />

          <!-- <div class="card ba-w-100" v-for="(theme, indx) in emails.themes" v-if="emails.themes.length > 0" :key="indx">
            <div class="card-header ba-flex ba-ai-center ba-jc-sb" :id="`headingEmailTheme${indx}`">
              <span class="py-1 d-inline-block collapsed" data-toggle="collapse"
                :data-target="`#collapseEmailTheme${indx}`" aria-expanded="true"
                :aria-controls="`collapseEmailTheme${indx}`">
                {{ theme.name }}
              </span>
              <div class="ba-flex ba-gp-06">
                <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="editEmailTheme(theme)">
                  <builderall-icon code='edit' />
                </button>
                <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="deleteEmailTheme(indx)">
                    <builderall-icon code='trash' />
                </button>
                <span class="d-inline-block float-right" data-toggle="collapse"
                  :data-target="`#collapseEmailTheme${indx}`" aria-expanded="true"
                  :aria-controls="`collapseEmailTheme${indx}`">
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
            </div>
            <div :id="`collapseEmailTheme${indx}`" class="collapse" :aria-labelledby="`headingEmailTheme${indx}`" data-parent="#accordion-emails">
              <div class="card-body">
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" :id="`nav-${index}-${config.type}-tab`" data-toggle="tab"
                      :href="`#nav-${index}-${config.type}`" role="tab" :aria-controls="`nav-${index}-${config.type}`"
                      aria-selected="true" v-for="(config, index) in theme.configs"><span class="ba-montserrat-700 ba-text-14">{{
                        $t(`ct-email-theme-${config.type}`) }}</span>
                    </a>
                    <hr class='ba-hr-row'>
                  </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                  <div class="tab-pane fade show active p-2" :id="`nav-${index}-${config.type}`" role="tabpanel"
                    :aria-labelledby="`nav-${index}-${config.type}-tab`" v-for="(config, index) in theme.configs">
                    <div class="ba-grid ba-w-100">
                      <label for="subject" class="ba-custom-label">{{ $t('ct-subject') }}</label>
                        <input type="text" class="ba-input ba-md" id="subject" v-model="config.subject">
                    </div>
                    <div class="ba-w-100 ba-pd-t-1">
                        <CKEditor v-model="config.content"
                          :id="`CKEditor-${indx}-${(theme.name.replace(' ', '-').replace(/[^\w\s]/gi, ''))}`"
                          :toolbar="CKEditor_config.toolbar" :fullPage="false" :height="CKEditor_config.height"
                          :tags="tags"></CKEditor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </form>
    </div>

    <sweet-modal ref="actionEmail" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t("ct-email-theme-name") }}</h5>
        <button
          class="ba-btn ba-btn-close ba-sm ba-rounded"
          @click="closeActionEmail"
        >
          <builderall-icon code="64f7" />
        </button>
      </div>
      <hr class="ba-hr-row" />
      <div class="ba-grid ba-mg-y-1">
        <div ref="form-email-action">
          <div class="ba-box-input">
            <label for="theme-email" class="ba-custom-label">{{
              $t("ct-email-theme-name")
            }}</label>
            <input
              id="theme-email"
              v-model="newTheme.name"
              :class="{ 'ba-error': errors.has('newTheme.name') }"
              type="text"
              class="ba-input ba-md"
              name="name"
              required="required"
              @keydown="errors.clear('newTheme.name')"
            />
            <span
              v-if="errors.has('newTheme.name')"
              class="ba-validation-text"
              v-text="errors.get('newTheme.name')"
            />
          </div>
        </div>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button
          slot="button"
          class="ba-btn ba-md ba-light"
          @click.prevent="closeActionEmail"
        >
          {{ $t("ct-cancel") }}
        </button>
        <button
          slot="button"
          class="ba-btn ba-md ba-blue"
          @click.prevent="addEmailTheme"
        >
          {{ $t("ct-save") }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import NavComponent from "../layout/nav/Nav.vue";
import ModalDeleteComponent from "./../components/ModalDelete";
import SiteSidebarComponent from "./../layout/site/SiteSidebar";
import CKEditor from "./../components/CKEditor";
import { SweetModal } from "sweet-modal-vue";
import Errors from "../../../js/base/Errors";
import AlertBoxComponent from "../../commons/AlertBoxComponent.vue";
import {
  edit,
  getAll
} from "./../../../js/services/restrictArea/automaticEmails";

export default {
  name: "Emails",
  components: {
    NavComponent,
    ModalDeleteComponent,
    SiteSidebarComponent,
    CKEditor,
    SweetModal,
    AlertBoxComponent
  },

  data() {
    return {
      errors: new Errors(),
      CKEditor_config: {
        height: "250px",
        toolbar: [
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Source"]
          },
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: ["Cut", "Copy", "Paste", "PasteText", "-", "Undo", "Redo"]
          },

          { name: "links", items: ["Link", "Unlink"] },

          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock"
            ]
          },
          { name: "colors", items: ["TextColor", "BGColor"] },
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] }
        ]
      },
      tags: [
        {
          name: "user-name",
          tag: "[USER_NAME]",
          label: "user-name"
        },

        {
          name: "user-email",
          tag: "[USER_EMAIL]",
          label: "user-email"
        },
        {
          name: "user-password",
          tag: "[USER_PASSWORD]",
          label: "user-password"
        }
      ],
      website: { encrypted_id: "" },
      content: "",

      emails: {
        themes: []
      },

      newTheme: {
        action: "create",
        name: "",
        configs: [
          {
            type: "welcome",
            subject: "Welcome to members area",
            content:
              "<table cellpadding=\"0\" cellspacing=\"0\" class=\"wrapper\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #f8fafc; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <tbody> <tr> <td align=\"center\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box;\"> <table cellpadding=\"0\" cellspacing=\"0\" class=\"content\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <tbody> <tr> <td class=\"header\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 25px 0; text-align: center;\"><a href=\"\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #bbbfc3; font-size: 19px; font-weight: bold; text-decoration: none; text-shadow: 0 1px 0 white;\">Builderall <\/a><\/td> <\/tr> <!-- Email Body --> <tr> <td cellpadding=\"0\" cellspacing=\"0\" class=\"body\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #ffffff; border-bottom: 1px solid #edeff2; border-top: 1px solid #edeff2; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"inner-body\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #ffffff; margin: 0 auto; padding: 0; width: 570px; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 570px;\" width=\"570\"><!-- Body content --> <tbody> <tr> <td class=\"content-cell\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 35px;\"> <h1 style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 19px; font-weight: bold; margin-top: 0; text-align: left;\">Hello, <span>[USER_NAME]<\/span>!<\/h1> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Email:\u00A0<span>[USER_EMAIL]<\/span><\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Password:\u00A0<span>[USER_PASSWORD]<\/span><\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Thank you for using our application!<\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Regards,<br \/> Builderall<\/p> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <tr> <td style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box;\"> <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"footer\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; margin: 0 auto; padding: 0; text-align: center; width: 570px; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 570px;\" width=\"570\"> <tbody> <tr> <td align=\"center\" class=\"content-cell\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 35px;\"> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; line-height: 1.5em; margin-top: 0; color: #aeaeae; font-size: 12px; text-align: center;\">\u00A9 2020 Builderall. All rights reserved.<\/p> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <\/tbody><\/table>"
          }
        ]
      }
    };
  },

  mounted() {
    this.website.encrypted_id = this.$route.params.website_id;

    getAll(this.website.encrypted_id)
      .then(response => {
        if (response.data.success) this.emails.themes = response.data.data;
      })
      .finally(() => {
        this.$loading.hide();
      });
  },

  methods: {
    clearString(string) {
      return string.toUpperCase().trim();
    },

    validate() {
      return this.errors.any();
    },

    save() {
      let data = this.emails;
      data.website = this.website;

      if (!this.validate()) {
        this.$loading.show();
        edit(data)
          .then(response => {
            if (response.data.success)
              this.$snotify.success(this.$t("ct-saved-successfully"));
            else this.$snotify.error(this.$t("ct-error-saving"));
          })
          .catch(() => {
            this.$snotify.error(this.$t("ct-error-saving"));
          })
          .finally(() => {
            this.$loading.hide();
            this.closeActionEmail();
          });
      }
    },

    addEmailTheme() {
      this.errors.validateFormat(this.$refs["form-email-action"], "newTheme");

      var index = this.emails.themes
        .map(function(theme) {
          return theme.name;
        })
        .indexOf(this.newTheme.name);

      if (
        this.emails.themes.find(
          (theme, i) =>
            this.clearString(theme.name) ===
              this.clearString(this.newTheme.name) && i !== index
        )
      )
        this.errors.add("name", "validation-already-been-taken", "newTheme");

      if (!this.validate()) {
        if (this.newTheme.action === "create")
          this.emails.themes.push(this.newTheme);

        this.closeActionEmail();
      }
    },

    editEmailTheme(theme) {
      this.newTheme = theme;
      this.newTheme.action = "update";

      this.$refs.actionEmail.open();
    },

    deleteEmailTheme(index) {
      this.emails.themes.splice(index, 1);
    },

    emptyNewTheme() {
      this.newTheme = {
        action: "create",
        name: "",
        configs: [
          {
            type: "welcome",
            subject: "Welcome to members area",
            content:
              "<table cellpadding=\"0\" cellspacing=\"0\" class=\"wrapper\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #f8fafc; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <tbody> <tr> <td align=\"center\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box;\"> <table cellpadding=\"0\" cellspacing=\"0\" class=\"content\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <tbody> <tr> <td class=\"header\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 25px 0; text-align: center;\"><a href=\"\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #bbbfc3; font-size: 19px; font-weight: bold; text-decoration: none; text-shadow: 0 1px 0 white;\">Builderall <\/a><\/td> <\/tr> <!-- Email Body --> <tr> <td cellpadding=\"0\" cellspacing=\"0\" class=\"body\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #ffffff; border-bottom: 1px solid #edeff2; border-top: 1px solid #edeff2; margin: 0; padding: 0; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;\" width=\"100%\"> <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"inner-body\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; background-color: #ffffff; margin: 0 auto; padding: 0; width: 570px; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 570px;\" width=\"570\"><!-- Body content --> <tbody> <tr> <td class=\"content-cell\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 35px;\"> <h1 style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 19px; font-weight: bold; margin-top: 0; text-align: left;\">Hello, <span>[USER_NAME]<\/span>!<\/h1> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Email:\u00A0<span>[USER_EMAIL]<\/span><\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Password:\u00A0<span>[USER_PASSWORD]<\/span><\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Thank you for using our application!<\/p> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; color: #3d4852; font-size: 16px; line-height: 1.5em; margin-top: 0; text-align: left;\">Regards,<br \/> Builderall<\/p> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <tr> <td style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box;\"> <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"footer\" role=\"presentation\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; margin: 0 auto; padding: 0; text-align: center; width: 570px; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 570px;\" width=\"570\"> <tbody> <tr> <td align=\"center\" class=\"content-cell\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; padding: 35px;\"> <p style=\"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; box-sizing: border-box; line-height: 1.5em; margin-top: 0; color: #aeaeae; font-size: 12px; text-align: center;\">\u00A9 2020 Builderall. All rights reserved.<\/p> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <\/tbody> <\/table> <\/td> <\/tr> <\/tbody><\/table> <div id=\"gtx-trans\" style=\"position: absolute; left: 489px; top: 95px;\"><div class=\"gtx-trans-icon\">\u00A0<\/div><\/div>"
          }
        ]
      };
    },

    closeActionEmail() {
      this.$refs.actionEmail.close();
      this.errors.clear();
      this.emptyNewTheme();
    }
  }
};
</script>

<style lang="scss">
.cke_top {
  border-bottom: 1px solid #dde5ed !important;
  background: #f1f5f9 !important;
  padding: 6px 8px 2px !important;
  white-space: normal !important;
}

.cke_chrome {
  display: block !important;
  border: 1px solid #dde5ed !important;
  border-radius: 6px !important;
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border: unset !important;
  border-top: 1px solid #0080fc !important;
  color: #0080fc !important;
  border-radius: 0 !important;
  background-color: #ffff !important;
}

.nav-tabs {
  border-bottom: unset !important;
}

.nav-link {
  padding: 0.5rem 0.5rem !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  color: #425e7d99 !important;
  background-color: #f6f8fb !important;
  border-radius: 4px !important;
}

.nav-link:hover {
  color: #0080fc !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Emails.vue